
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/auto",
      function () {
        return require("private-next-pages/products/auto/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/auto"])
      });
    }
  